import { useMutation, useQueryClient } from '@tanstack/react-query'
import quickActionApi, { QuickActionRequest } from '../services/quickActionApi'
import { dashboardQueryKeys } from './useDashboardQueries'
import { sampleQueryKeys } from './useSampleQueries'

export const useCreateQuickAction = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: QuickActionRequest) => quickActionApi.create(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: dashboardQueryKeys.all })
      queryClient.invalidateQueries({ queryKey: sampleQueryKeys.all })
    }
  })
}
